const employerRoutes = {
  employers: "/employers",
  employerDetails: "/employers/details/:employer_id",
  DuplicatesEmployers: "/employers/duplicate/:user_id",
};

export default employerRoutes;
